import Image from 'next/image';
import HsaFsaCheckIcon from './assets/hsaFsaCheck.png';

export const HsaFsaCheck = () => {
  return <Image alt='' height={16} src={HsaFsaCheckIcon} width={16} />;
};
